export default __webpack_public_path__ + "static/media/CAMARAnecesaria.53d0e19a.svg";